import i18nEnum from '@/i18ns/vi/i18nEnum';
import {useContextStore} from '@/stores/context';
import {MSConstant} from '@/commons/wildcards';

export default [
  {
    path: '/dashboard-tracking',
    name: 'DashboardTracking',
    component: () => import('@/views/tracking/DashboardTrackingOverview.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.HCSN],
    },
  },
  {
    path: '/dashboard-tracking-cqsn',
    name: 'DashboardTrackingCQSN',
    component: () => import('@/views/tracking/DashboardTrackingCQSNOverview.vue'),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
  {
    path: '/tracking-progress/:key?',
    name: 'TrackingImplementation',
    component: () => { 
      var context = useContextStore();

      if (context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.SuNghiep) {
        return import(
          '@/views/implementationTracking/TrackingImplementation.vue'
        );
      }
    

      },
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.HCSN],
    },
  },
    {
    path: '/tracking-progress-cqsn/:key?',
    name: 'TrackingImplementationCQSN',
    component: () => { 
      var context = useContextStore();
      
      if (context.Context.OrganizationPackCodeType == MSConstant.OrganizationPackCodeType.ChuQuanSuNghiep) {
        return import(
          '@/views/implementationTrackingCQSN/TrackingImplementationDVCQSN.vue'
        );
      }

      },
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
];
